module.exports = __webpack_public_path__ + "static/product5-a-da9fd254e546296870256cc8db9e7126.png";